export { Home } from "./Home/Home"
export { ContactUs } from "./ContactUs/ContactUs";
export { Login } from "./Login/Login";
export { Forget } from "./Forget/Forget";
export { Reset } from "./Reset/Reset";
export { Services } from './Services/Services';
export { About } from './About/About';
export { Specialties } from './Specialties/Specialties';
export { Portal } from './Portal/Portal';
export { ServiceDetail } from './ServiceDetail/ServiceDetail';